import styled from "styled-components";
import { device } from "../../themes/Breakpoints";

export const ChartWrapper = styled.div`
   display: flex;
   align-items: center;
   width: 100%;
   max-width: 640px;
   margin: 0 auto;
   justify-content: space-between;
  @media ${device.mobileL} {
    flex-direction:column;
  }
  @media ${device.mobileM} {
    flex-direction:column;
  }
  @media ${device.mobileS} {
    flex-direction:column;
  }
`;

export const ChartDough = styled.div`
  width: 100%;
  max-width: 400px;
  @media ${device.mobileL} {
    max-width: 300px;
  }
  @media ${device.mobileM} {
    max-width: 200px;
  }
  @media ${device.mobileS} {
    max-width: 200px;
  }
`;
export const ChartInfo = styled.div`
 
`;
export const ChartInfoItem = styled.div`
  display: flex;
  align-items: center;
  gap:24px;
  margin-bottom: 19px;
  span {
    width: 24px;
    height: 24px;
    border-radius: 2px;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 27px;
    color: #46484A;
  }
`;
export const InfoTitle = styled.p`
    font-weight: 400;
    font-size: 20px;
    line-height: 27px;
    color: #022142;
    text-align: center;
    margin-top: 60px;
    margin-bottom: 20px;
  @media ${device.tabletL} {
    margin-top: 40px;
  }
  @media ${device.tablet} {
    margin-top: 40px;
  }
  @media ${device.mobileL} {
    margin-top: 20px;
    margin-bottom: 0;
    line-height: 22px;
  }
  @media ${device.mobileM} {
    margin-top: 20px;
    margin-bottom: 0;
    line-height: 22px;
  }
  @media ${device.mobileS} {
    margin-top: 20px;
    margin-bottom: 0;
    line-height: 22px;
  }
`;